// extracted by mini-css-extract-plugin
export default {"table":"CustomizationsTable_table__Sr+XZ"};